import { VisuallyHidden, type HTMLChakraProps } from "@chakra-ui/react";

import { Field } from "../../form-control/form-control";

type FieldLabelProps = HTMLChakraProps<"label">;

import { injectRequiredAsteriskAfterTitle } from "@/helpers/survey";

import { HTMLWrapper } from "../../html-wrapper/html-wrapper";

interface QuestionTitleProps extends FieldLabelProps {
  id?: string;
  required?: boolean;
  labelType?: "label" | "legend" | "fieldset";
  labelClassName?: string;
  accessibilityTextOfRequired?: string;
  children: string;
}

const QuestionTitle = (props: QuestionTitleProps): JSX.Element => {
  const {
    id,
    required,
    children,
    labelClassName,
    labelType = "label",
    accessibilityTextOfRequired,
    htmlFor,
    css: restCss,
    ...rest
  } = props;

  const labelHtml =
    required && children
      ? injectRequiredAsteriskAfterTitle(children)
      : children;

  return (
    <Field.Label
      id={id}
      htmlFor={htmlFor}
      className={labelClassName}
      as={labelType}
      mb={0}
      w="full"
      hideRequiredIndicator={!!required}
      css={restCss}
      {...rest}
    >
      <HTMLWrapper
        html={labelHtml}
        isFullWidth
        as="div"
        css={
          required
            ? {
                "& > :last-child": { display: "revert" },
                "& .ehq-required-asterisk": { color: "red.600" }
              }
            : undefined
        }
      />
      {required && accessibilityTextOfRequired && (
        <VisuallyHidden>{accessibilityTextOfRequired}</VisuallyHidden>
      )}
    </Field.Label>
  );
};

export { QuestionTitle };
export type { QuestionTitleProps };
